import styled from 'styled-components';

export const SVGIconWrapper = styled.div`
  display: inline;
  align-items: center;
  justify-content: center;
  svg {
    width: 20px;
    height: 20px;
    object-fit: contain;
    margin-right: 10px;
    align: center;
  },
`;
